
function initKioskMode () {
  localStorage.setItem('kioskMode', true)
  kioskMode()
}

function exitKioskMode () {
  localStorage.setItem('kioskMode', false)
}

function kioskModeMaybe () {
  if (localStorage.getItem('kioskMode') === 'true') {
    kioskMode()
  }
}

async function kioskMode () {
  const { default: KioskMode } = await import('./qr-code-widget.js')
  KioskMode()
}

export default function () {
  switch (window.location.hash) {
    case '#on-kiosk':
      initKioskMode()
      break
    case '#off-kiosk':
      exitKioskMode()
      break
    default:
      kioskModeMaybe()
  }
}
